module.exports = __webpack_public_path__ + "img/che3.e1c7c5e5.png";